
import {IStack} from './stack.interface';

export class Stack<T> implements IStack {
    protected _elements:T[];
    protected _maxSize:number;

    constructor(maxSize:number = 16384 /** 2^14 */) {
        this._maxSize = maxSize;
        this._elements = [];
    }

    public push(elm:T):boolean {
        if (this.size === this._maxSize) {
            return false;
        }
        this._elements.push(elm);
        return true;
    }

    public clear():boolean {
        this._elements = [];
        return true;
    }

    public pop():T {
        if (this.isEmpty()) {
            return null;
        }
        return this._elements.pop();
    }

    public peek():T {
        if (this.isEmpty()) {
            return null;
        }
        return this._elements[this.size - 1];
    }

    public isEmpty():boolean {
        return (this.size === 0);
    }


    // Internals
    get size() {
        return this._elements.length;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/dataStructures/collections/stack/stack.structure.ts